<!--
 * @Author: quwandong
 * @Date: 2022-05-18 13:50:59
 * @LastEditors: quwandong
 * @LastEditTime: 2022-05-20 22:21:35
 * @FilePath: \motion\src\views\Cooperative\LoanOrder\DiscountDetail.vue
 * @Description: 贴息查看
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main" v-loading="loading">
      <div class="header_title">
        <div class="number">订单编号：{{ applyNum }}</div>
        <div class="time">下单时间：{{ applyTime }}</div>
      </div>
      <div class="status">
        <div class="status-info">
          <img
            v-if="detail.status === 'NS9902'"
            src="@/assets/loanOrder/icon_tiexi_daishenqing.png"
          />
          <img
            v-if="detail.status === 'NS01'"
            src="@/assets/loanOrder/icon_tiexi_shenqingtij.png"
          />
          <img
            v-if="detail.status === 'NS02'"
            src="@/assets/loanOrder/icon_tiexi_daishenqingduixian.png"
          />
          <img
            v-if="detail.status === 'NS03' || detail.status === 'NS06'"
            src="@/assets/loanOrder/icon_tiexi_bohui.png"
          />
          <img
            v-if="detail.status === 'NS04'"
            src="@/assets/loanOrder/icon_tiexi_duixiantijiao.png"
          />
          <img
            v-if="detail.status === 'NS07'"
            src="@/assets/loanOrder/icon_tiexi_yiduixian.png"
          />
          <div>
            <div>{{ detail.statusName }}</div>
            <div
              class="reason"
              v-if="detail.status === 'NS03' || detail.status === 'NS06'"
            >
              驳回原因：{{ getStatusRemark(detail.status) }}
            </div>
          </div>
        </div>
        <div class="status-step">
          <el-steps :active="active" align-center>
            <el-step
              :icon="getStatusIcon('NS01')"
              title="申请贴息提交"
              :description="getStatusTime('NS01')"
            ></el-step>
            <el-step
              v-if="detail.status === 'NS03'"
              class="error"
              icon="el-icon-error"
              title="贴息申请驳回"
              :description="getStatusTime('NS03')"
            ></el-step>
            <el-step
              v-else
              :icon="getStatusIcon('NS02')"
              title="贴息申请通过"
              :description="getStatusTime('NS02')"
            ></el-step>
            <el-step
              :icon="getStatusIcon('NS04')"
              :description="getStatusTime('NS04')"
              title="申请兑现提交"
            ></el-step>
            <el-step
              v-if="detail.status === 'NS06'"
              class="error"
              icon="el-icon-error"
              title="申请兑现驳回"
              :description="getStatusTime('NS06')"
            ></el-step>
            <el-step
              v-else
              :icon="getStatusIcon('NS07')"
              :description="getStatusTime('NS07')"
              title="已兑现"
            ></el-step>
            <el-step
              :icon="getStatusIcon('NS07')"
              :description="getStatusTime('NS07')"
              title="贴息完成"
            ></el-step>
          </el-steps>
        </div>
      </div>
      <div class="block">
        <div class="plate">
          <div class="title">
            <h2 class="plate-title">用户信息</h2>
          </div>
        </div>
        <table class="table table-info">
          <tr>
            <td class="title">客户姓名</td>
            <td class="info">{{ detail.name }}</td>
            <td class="title">身份证号码</td>
            <td class="info">{{ detail.idCard }}</td>
            <td class="title">联系方式</td>
            <td class="info">{{ detail.phone }}</td>
          </tr>
          <tr>
            <td class="title">省市县乡</td>
            <td class="info">{{ detail.nowAddress }}</td>
            <td class="title">家庭住址</td>
            <td class="info">{{ detail.nowAddressDetail }}</td>
            <td class="title"></td>
            <td class="info"></td>
          </tr>
        </table>
      </div>
      <div class="block">
        <div class="plate">
          <div class="title">
            <h2 class="plate-title">贴息政策</h2>
          </div>
        </div>
        <table class="table table-info">
          <tr>
            <td class="title">机具大类</td>
            <td class="info">{{ detail.bigClass }}</td>
            <td class="title">机具小类</td>
            <td class="info">{{ detail.smallClass }}</td>
            <td class="title">机具品目</td>
            <td class="info">{{ detail.machineryItem }}</td>
          </tr>
          <tr>
            <td class="title">机具品牌</td>
            <td class="info">{{ detail.brandName }}</td>
            <td class="title">机具型号</td>
            <td class="info">{{ detail.prodModel }}</td>
            <td class="title">经销商</td>
            <td class="info">{{ detail.agencyName }}</td>
          </tr>
          <tr>
            <td class="title">生产厂商</td>
            <td class="info">{{ detail.firmName }}</td>
            <td class="title">购机价格（元）</td>
            <td class="info">{{ detail.purchasePrice }}</td>
            <td class="title">补贴金额（元）</td>
            <td class="info">{{ detail.perSubsidyAmt }}</td>
          </tr>
          <tr>
            <td class="title">贴息比例</td>
            <td class="info">{{ detail.subsidyRatio }}%</td>
            <td class="title">贴息时长</td>
            <td class="info">{{ detail.subsidyDuration }}个月</td>
            <td class="title">贴息限额（元）</td>
            <td class="info">{{ detail.subsidyMaxAmount }}</td>
          </tr>
        </table>
      </div>

      <div class="block" v-if="showApplyDiscount">
        <div class="plate">
          <div class="title">
            <h2 class="plate-title">申请贴息资料</h2>
          </div>
        </div>
        <el-table
          :data="applyDiscountData"
          style="width: 100%; margin-top: 10px"
        >
          <el-table-column prop="disburseAmount" label="支用金额（元）">
          </el-table-column>
          <el-table-column prop="disburseDuration" label="期限（月）">
          </el-table-column>
          <el-table-column prop="yearRatio" label="年利率（%）">
          </el-table-column>
          <el-table-column prop="repaymentType" label="还款方式">
          </el-table-column>
        </el-table>
        <div class="second-title">支用详情</div>
        <div class="item">
          <div class="li" v-for="(item, index) in detail.fileList" :key="index">
            <template v-if="item.fileClassifCode == 'DISBURSE_DETAIL_PIC'">
              <img :src="item.tFileDataDtos[0].picPath" alt="" />
            </template>
          </div>
        </div>
      </div>
      <div class="block" v-if="showApplyCash">
        <div class="plate">
          <div class="title">
            <h2 class="plate-title">申请兑现资料</h2>
          </div>
        </div>
        <el-table :data="applyCashData" style="width: 100%; margin-top: 10px">
          <el-table-column prop="loanDate" label="贷款发放时间">
          </el-table-column>
          <el-table-column prop="settleDate" label="贷款结清时间">
          </el-table-column>
          <el-table-column prop="actualUseDays" label="实际使用天数">
          </el-table-column>
          <el-table-column prop="exSubsidyAmount" label="预计贴息金额（元）">
          </el-table-column>
        </el-table>
        <div class="second-title">结清证明</div>
        <div class="item">
          <div class="li" v-for="(item, index) in detail.fileList" :key="index">
            <template v-if="item.fileClassifCode == 'SETTLE_REPAYMENT_PIC'">
              <img :src="item.tFileDataDtos[0].picPath" alt="" />
            </template>
          </div>
        </div>
      </div>
      <div class="block" v-if="showApplyCash">
        <div class="plate">
          <div class="title">
            <h2 class="plate-title">收款账户</h2>
          </div>
        </div>
        <table class="table table-info">
          <tr>
            <td class="title">账户名</td>
            <td class="info">{{ detail.cusBankName }}</td>
            <td class="title">账户号</td>
            <td class="info">{{ detail.cusBankCardnum }}</td>
            <td class="title">开户银行</td>
            <td class="info">{{ detail.payBankName }}</td>
          </tr>
          <tr>
            <td class="title">开户行名称</td>
            <td class="info">{{ detail.payBankBranch }}</td>
            <td class="title">预留手机号</td>
            <td class="info">{{ detail.cusBankPhone }}</td>
            <td class="title"></td>
            <td class="info"></td>
          </tr>
        </table>
      </div>
      <div class="block" v-if="showApplyCashed">
        <div class="plate">
          <div class="title">
            <h2 class="plate-title">兑现信息</h2>
          </div>
        </div>
        <el-table :data="cashData" style="width: 100%; margin-top: 10px">
          <el-table-column prop="paidTime" label="付款日期"> </el-table-column>
          <el-table-column prop="exSubsidyAmount" label="付款金额（元）">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-main>
</template>

<script>
export default {
  name: 'LoanOrderDiscount',
  data() {
    return {
      detail: {},
      applyDiscountData: [], // 申请贴息资料
      applyCashData: [], //申请兑现资料
      statusRecords: [], // 状态步骤数据
      cashData: [], // 兑现信息
      active: 1,
      applyNum: '',
      applyTime: '',
      loading: false,
    }
  },
  computed: {
    showApplyDiscount() {
      return this.detail.status !== 'NS9902'
    },
    showApplyCash() {
      return ['NS06', 'NS04', 'NS07'].includes(this.detail.status)
    },
    showApplyCashed() {
      return this.detail.status === 'NS07'
    },
  },
  mounted() {
    this.id = this.$route.query.id
    this.applyNum = this.$route.query.applyNum
    this.applyTime = this.$route.query.applyTime
    this.getDiscountDetailById()
  },
  methods: {
    /**
     * @description: 获取订单贴息详情
     * @Author: quwandong
     * @Date: 2022-05-18 10:21:21
     */
    async getDiscountDetailById() {
      try {
        this.loading = true
        const res = await this.$http.loanOrder.getDiscountDetailById({
          applyId: this.id,
        })
        if (res.status == 1) {
          this.detail = res.data.data
          this.applyDiscountData = [
            {
              disburseAmount: this.detail.disburseAmount || 0,
              disburseDuration: this.detail.disburseDuration || 0,
              yearRatio: this.detail.yearRatio || 0,
              repaymentType: this.detail.repaymentType || 0,
            },
          ]
          this.applyCashData = [
            {
              loanDate: this.detail.loanDate,
              settleDate: this.detail.settleDate,
              actualUseDays: this.detail.actualUseDays || 0,
              exSubsidyAmount: this.detail.exSubsidyAmount || 0,
            },
          ]

          this.statusRecords = this.detail.statusRecords

          this.active = this.detail.statusRecords.length

          this.cashData = [
            {
              paidTime:
                this.statusRecords.length > 0
                  ? this.statusRecords[0].paidTime
                  : '',
              exSubsidyAmount: this.detail.exSubsidyAmount || 0,
            },
          ]
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    /**
     * @description: 获取 状态步骤的icon
     * @param status
     * @Author: quwandong
     * @Date: 2022-05-19 10:34:42
     */
    getStatusIcon(status) {
      const target = this.statusRecords.findIndex(
        (item) => status === item.status
      )
      return target > -1 ? 'el-icon-success' : ''
    },
    /**
     * @description: 获取 状态步骤的time
     * @param status
     * @Author: quwandong
     * @Date: 2022-05-19 10:34:42
     */
    getStatusTime(status) {
      const target = this.statusRecords.find((item) => status === item.status)
      return target ? target.time : ''
    },
    /**
     * @description: 获取 状态步骤的remark
     * @param status
     * @Author: quwandong
     * @Date: 2022-05-19 10:34:42
     */
    getStatusRemark(status) {
      const target = this.statusRecords.find((item) => status === item.status)
      return target ? target.remark : ''
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.plate-title {
  @include plate-title;
  color: black;
  margin-top: 10px;
  span {
    color: #acacac;
    font-size: 14px;
  }
}
.main {
  padding-top: 20px !important;

  .second-title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #242424;
    line-height: 36px;
    margin: 10px 0;
  }
  .card {
    img {
      height: 189px;
      margin-top: 10px;
    }
  }
  .header_title {
    color: #5f6868;
    display: flex;
    font-size: 16px;
    .time {
      margin-left: 20px;
    }
  }
  .status {
    display: flex;
    align-items: center;
    padding-top: 20px;
    padding-bottom: 10px;
    height: 120px;
    box-sizing: border-box;

    .status-info {
      display: flex;
      align-items: center;
      height: 100%;
      width: 360px;
      text-align: center;
      border-right: 1px solid #e7e7e7;
      font-size: 20px;
      color: #018388;
      font-weight: bold;
      flex-shrink: 0;

      > div {
        padding: 0 10px;
        text-align: left;
        flex: 1;
      }

      .text-red {
        color: #ff0101;
      }

      .reason {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ff0101;
      }

      i {
        display: inline-block;
        width: 53px;
        height: 49px;

        &.daishenqing {
          height: 37px;
          background: url('~assets/loanOrder/icon_tiexi_daishenqing.png');
          background-size: 100% 100%;
        }
      }

      span {
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #018388;
        line-height: 29px;
        margin-left: 10px;
      }
    }

    .status-step {
      margin-left: 20px;
      margin: 0 auto;
    }
  }
  .item {
    display: flex;
    margin-bottom: 20px;
    .li {
      margin-left: 70px;
      color: #333333;
      img {
        height: 180px;
      }
      p {
        line-height: 35px;
      }
    }
    .li:nth-child(1) {
      margin-left: 0;
    }
  }
}
.table-info {
  width: 100%;
  border: 1px solid #e9edf7;
  border-collapse: collapse;
  // margin-bottom: 20px;
  position: relative;
  tr {
    width: 100%;
    img {
      height: 122px;
    }
    td {
      height: 50px;
      padding: 8px;
      font-size: 16px;
      border-bottom: 1px solid #e9edf7;
      box-sizing: border-box;
      &.tit {
        div {
          display: flex;
          justify-content: center;
        }
      }
      &.title {
        width: 120px;
        text-align: right;
        color: #838383;
        background: #f8f9fc;
        box-sizing: border-box;
      }
      &.info {
        width: 20%;
        color: #333333;
        .ul {
          display: flex;
          .item {
            text-align: center;
            margin-left: 30px;
            cursor: pointer;
            img {
              height: 40px;
            }
          }
        }
        .open {
          padding: 5px 10px 5px 10px;
          border: 1px solid #eeeeee;
          cursor: pointer;
        }
      }
    }
  }
}
::v-deep .el-dialog__headerbtn {
  font-size: 28px !important;
}

::v-deep {
  .el-step {
    min-width: 180px;

    &.error {
      .el-step__main {
        .el-step__title {
          color: #ff0101;
        }
      }
    }
    .el-step__icon-inner[class*='el-icon']:not(.is-status) {
      font-size: 40px;
    }
    .el-step__line {
      top: 18.5px;
    }
    .el-step__icon {
      height: 40px;
      color: #018388;
      .el-icon-error {
        color: #ea4646;
      }
      &.is-text {
        width: 40px;
        height: 40px;
        border: 1px solid #018388;
        color: #018388;
        font-size: 16px;
      }
    }
    .el-step__title {
      font-size: 16px;
      color: #333333;
      font-weight: normal;
    }
    .el-step__description {
      font-size: 14px;
      color: #666666;
      padding: 0 10px;
    }
  }
}
</style>